import {
    Grid,
    GridProps,
    Heading,
    Text,
} from '@chakra-ui/react';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { RichText } from 'shared';

export type CakeToOrderPageMainPortionCardProps = {
    value: number
    measure: string
    description: any
    weight?: number
    price?: number
    pricePrefix?: string | null
    currency?: string
    isActive: boolean
} & GridProps & React.RefAttributes<HTMLDivElement>

export const CakeToOrderPageMainPortionCard
: React.FC<CakeToOrderPageMainPortionCardProps> = ({
    value,
    measure,
    description,
    price,
    pricePrefix,
    currency,
    isActive,
    ...props
}) => (
    <Grid
        templateColumns="1fr auto"
        {...props}
        background={isActive ? '#F8C9C4' : 'transparent'}
        borderBottom="3px solid #DDDDDD"
        gapY="1rem"
        gapX="2rem"
    >
        <Heading
            margin="auto auto 0 0"
            size="sm"
        >
            {value}
            {' '}
            {measure.toLocaleUpperCase()}
        </Heading>
        <Grid>
            <Text
                fontSize="2rem"
                padding="0"
                fontWeight="900"
                margin="auto 0 0 auto"
            >
                {pricePrefix}
                {' '}
                {price?.toLocaleString()}
                {' '}
                {currency}
            </Text>
        </Grid>
        <RichText
            fontSize="1rem"
            textAlign="justify"
            content={description}
            padding={0}
        />
    </Grid>
);
